import React from 'react';
import { useFormContext } from 'react-hook-form';

import TextField from '../../../forms/TextField';

export default function Lpu() {
  const {
    getValues,
  } = useFormContext();

  const associated = getValues('association.associated');
  if (associated) {
    return <TextField name="lpu" label="Campaign Variables" />;
  }

  return null;
}
